<template>
  <div>
    <header-admin :active-section="7" />
    <div class="tab-content">
      <ExportLogic
        :panel-title="trans('forms.dermicusExportsLabel')"
        :export-url="'/api/internal/admin/export'"
        :load-data="loadData"
        role="admin"
      />
    </div>
  </div>
</template>

<script>
import _has from "lodash/fp/has";
import _filter from "lodash/fp/filter";
import HeaderAdmin from "./Header.vue";
import ExportLogic from "../../app/practitioner-portal/generic/export/ExportLogic.vue";

export default {
  components: {
    HeaderAdmin,
    ExportLogic,
  },
  methods: {
    loadData: function (update) {
      update({ isLoading: true });
      axios
        .get("/api/internal/admin/export")
        .then((data) => {
          update({
            availableCenters: _filter(_has("id"), data.data.centers),
            availableRegions: _filter(_has("id"), data.data.regions),
            isLoading: false,
          });
        })
        .catch((error) => {
          update({ isLoading: false });
          this.userErrorMessage(error);
        });
    },
  },
};
</script>
